// The list's own filters, above the ranked multis on Today: how many legs, what
// the multi pays, and where it is written. Pure: choices and the words a pill
// prints, so the component, the summary line and the tests say them the same.
// Nothing here is ever an em dash (src/lib/copy-rules.test.js).

/** Legs: Any, a count, or five and up. `value` is what askSelections.legs holds. */
export const LEG_FILTERS = [
  { label: 'Any', value: null },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5+', value: { min: 5, max: 10 } },
];

/** Pays: a combined-price range, `{ min, max }`, or null for any price. */
export const PAY_FILTERS = [
  { label: 'Any', value: null },
  { label: 'Under $3', value: { max: 3 } },
  { label: '$3–$10', value: { min: 3, max: 10 } },
  { label: '$10–$50', value: { min: 10, max: 50 } },
  { label: '$50+', value: { min: 50 } },
];

const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

/** What a leg count reads as: "3", "5+", "2–4", or null for any. */
export function legsWord(legs) {
  if (!legs) return null;
  if (Number.isInteger(legs)) return String(legs);
  const hit = LEG_FILTERS.find((f) => same(f.value, legs));
  if (hit) return hit.label;
  if (legs.min === legs.max) return String(legs.min);
  return legs.max >= 10 ? `${legs.min}+` : `${legs.min}–${legs.max}`;
}

const dollars = (n) => `$${Number.isInteger(n) ? n : n.toFixed(2)}`;

/** What a price range reads as: "$3–$10", "Under $3", "$50+", or null for any. */
export function paysWord(odds) {
  if (!odds) return null;
  const hit = PAY_FILTERS.find((f) => same(f.value, odds));
  if (hit) return hit.label;
  const lo = Number.isFinite(odds.min) && odds.min > 1 ? odds.min : null;
  const hi = Number.isFinite(odds.max) ? odds.max : null;
  if (lo && hi) return `${dollars(lo)}–${dollars(hi)}`;
  if (lo) return `${dollars(lo)}+`;
  if (hi) return `Under ${dollars(hi)}`;
  return null;
}

export const isChoice = (value, current) => same(value, current);
